// @flow
/** @jsx jsx */
import universal from '@core-ui/universal';
import { jsx } from '@core-ui/react-stitch';
import {
  CLEAR_FILTER_BUTTON,
  ITEM_COUNT_ARIA_LABEL,
  ITEM_COUNT_TEXT,
} from '../localization-tokens';
import { localizeItemCount } from '../collaborators/localize-item-count';
import RailMarketingCurtain from '../components/rail-marketing-curtain';
import CategoryNavigation from '../components/CategoryNavigation';
// $FlowFixMe
import { BopisBarFragment } from '../bopis-bar-fragment';

const ClearButton = universal(import('@core-ui/clear-button'), {
  key: 'ClearButton',
});
const FacetBar = universal(import('@cat/facet-bar'), { key: 'default' });
const ItemCount = universal(import('@core-ui/item-count'), {
  key: 'ItemCount',
});

const marketingCurtainStyles = {
  display: 'inline-block',
};

const bottomMarketingCurtainStyles = () => ({
  ...marketingCurtainStyles,
  marginTop: '1.5rem',
});

const filterDetailsStyles = (theme) => ({
  width: '100%',
  paddingTop: '1rem',
  paddingBottom: '1rem',
  borderBottom: `1px solid ${theme.color.gray20}`,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: 'white',
  position: 'sticky',
  top: 0,
  zIndex: 150,
});

const getDesktopCategoryNavigationFragment = (leftNav) => {
  return leftNav?.length > 0 ? (
    <CategoryNavigation
      position="scrollable"
      key="category-navigation"
      categoryNavData={leftNav}
    />
  ) : null;
};

const getDesktopClearButtonFragment = (hasTags, localize, mediator) => {
  return hasTags ? (
    <ClearButton
      localizedButtonText={localize(CLEAR_FILTER_BUTTON)}
      mediator={mediator}
      accessibleFocusSelector="#facet-bar"
    />
  ) : null;
};

export const getDesktopExperience = (props: any) => {
  const {
    abbrBrand,
    selectedNodes,
    totalItemCount,
    hasTags,
    mediator,
    abbrNameForTealium,
    businessUnitId,
    categoryName,
    datalayer,
    pageType,
    facetOptions,
    appliedFacets,
    leftNav,
    localize,
    itemCountAndClearButtonRef,
    isSwitchContractEnabled,
    isOutOfStockFilterEnabled,
  } = props;

  const itemCountAriaLabel = localizeItemCount(
    localize,
    ITEM_COUNT_ARIA_LABEL,
    totalItemCount
  );

  const itemCountText = localizeItemCount(
    localize,
    ITEM_COUNT_TEXT,
    totalItemCount
  );

  const categoryNavigationFragment =
    getDesktopCategoryNavigationFragment(leftNav);
  const clearButtonFragment = getDesktopClearButtonFragment(
    hasTags,
    localize,
    mediator
  );

  return [
    <div
      position="top"
      id="top-left-rail-marketing-curtain"
      css={marketingCurtainStyles}
      key="top-left-rail-marketing-curtain"
    >
      <RailMarketingCurtain
        position="top"
        selectedNodes={selectedNodes}
        abbrBrand={abbrBrand}
      />
    </div>,
    categoryNavigationFragment,
    <section
      aria-label={localize('facet_bar.product_filters_aria_label')}
      id="facets"
      position="scrollable"
      key="product-filters-area-label"
    >
      <div css={filterDetailsStyles} ref={itemCountAndClearButtonRef}>
        <ItemCount ariaLabel={itemCountAriaLabel} text={itemCountText} />
        {clearButtonFragment}
      </div>
      <BopisBarFragment
        position={null}
        key="sticky-bopis-bar"
        abbrNameForTealium={abbrNameForTealium}
        businessUnitId={businessUnitId}
        categoryName={categoryName}
        datalayer={datalayer}
        mediator={mediator}
        pageType={pageType}
        selectedNodes={selectedNodes}
      />
      <FacetBar
        facets={facetOptions}
        appliedFacets={appliedFacets}
        isSwitchContractEnabled={isSwitchContractEnabled}
      />
    </section>,
    isOutOfStockFilterEnabled && (
      <div position="scrollable">{'OUT OF STOCK FILTER ACTIVE'}</div>
    ),
    <div
      position="scrollable"
      css={bottomMarketingCurtainStyles}
      key="scrollable-marketing-curtain"
    >
      <RailMarketingCurtain
        position="bottom"
        selectedNodes={selectedNodes}
        abbrBrand={abbrBrand}
      />
    </div>,
  ];
};
